import React from 'react';

interface PracticeDurationSelectProps {
  onDurationSelected: (duration_minutes: number) => void;
  onBack: () => void;
}

export const PracticeDurationSelect: React.FC<PracticeDurationSelectProps> = ({ onDurationSelected, onBack }) => {
  const durations = [
    { minutes: 5, label: '5 minutes', description: 'Quick practice session' },
    { minutes: 10, label: '10 minutes', description: 'Standard practice' },
    { minutes: 15, label: '15 minutes', description: 'Focused learning' },
    { minutes: 20, label: '20 minutes', description: 'Deep dive' },
    { minutes: 30, label: '30 minutes', description: 'Comprehensive practice' },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="relative mb-8">
        <button
          onClick={onBack}
          className="absolute left-0 top-1/2 -translate-y-1/2 p-2 rounded-full bg-white/50 dark:bg-gray-700/50 border border-gray-200/50 dark:border-gray-600/50 hover:bg-gray-50/80 dark:hover:bg-gray-700/80 transition-all duration-200 shadow-sm hover:shadow-md"
          aria-label="Back to topic selection"
        >
          <svg className="w-6 h-6 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
        </button>
        <h1 className="text-4xl font-bold text-center bg-gradient-to-r from-blue-600 via-indigo-500 to-purple-600 bg-clip-text text-transparent">
          How long would you like to practice?
        </h1>
      </div>

      <div className="text-center mb-8">
        <p className="text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
          Choose a duration that works best for your schedule. Research shows that shorter, more frequent sessions are most effective for learning.
        </p>
      </div>

      <div className="max-w-3xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {durations.map(({ minutes, label, description }) => (
            <button
              key={minutes}
              onClick={() => {
                console.log('Duration selected:', minutes);
                onDurationSelected(minutes);
              }}
              className="group p-6 rounded-xl border backdrop-blur-sm transition-all duration-200 bg-white/50 dark:bg-gray-700/50 border-gray-200/50 dark:border-gray-600/50 text-gray-700 dark:text-gray-300 hover:bg-gray-50/80 dark:hover:bg-gray-700/80 hover:shadow-md"
            >
              <div className="flex flex-col items-center text-center">
                <span className="text-2xl font-bold mb-2 text-gray-900 dark:text-white">
                  {label}
                </span>
                <span className="text-sm text-gray-500 dark:text-gray-400">
                  {description}
                </span>
                <div className="mt-4 w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};